import { render, staticRenderFns } from "./ActivitiesPage.vue?vue&type=template&id=1324a43d&scoped=true"
import script from "./ActivitiesPage.vue?vue&type=script&lang=js"
export * from "./ActivitiesPage.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesPage.vue?vue&type=style&index=0&id=1324a43d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324a43d",
  null
  
)

export default component.exports